<template>
  <span class="state" :class="status"></span>
</template>

<script>
export default {
  name: 'app-status-indicator',
  props: {
    status: {
      type: String,
      validator: value => ['pending', 'green', 'orange', 'red'].includes(value),
      default: 'pending'
    }
  }
}
</script>
